import React from 'react';
import PropTypes from 'prop-types';

export default class ResponsivenessScoreContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            responsivenessScore: null,
        };
    }

    componentDidMount() {
        return this.props
            .fetchData()
            .then(res =>
                this.setState(() => ({
                    responsivenessScore: res.body.responsivenessScore,
                }))
            )
            .catch(e => {
                throw e;
            });
    }

    childrenWithScore() {
        return React.Children.map(this.props.children, child =>
            React.cloneElement(child, {
                score: this.state.responsivenessScore,
            })
        );
    }

    render() {
        return <div>{this.childrenWithScore()}</div>;
    }
}

ResponsivenessScoreContainer.propTypes = {
    fetchData: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/responsiveness-score/components/responsiveness-score-container.jsx